const computeStyle = ({ element, depth=0 }) => {
  const elementRect = element.getBoundingClientRect()
  const elementComputedStyle = getComputedStyle(element)
  const elementComputedStyleProperties = [
    `borderRadius`,
    `background`,
    `minWidth`,
    `minHeight`,
    `fontFamily`,
    `fontWeight`,
    `fontSize`,
    `letterSpacing`,
    `lineHeight`,
    `color`,
    `backgroundImage`,
    `boxShadow`,
    `padding`
  ]

  const value = {
    opacity: 1,

    ...depth === 0
      ? {
        position: `absolute`,
        top: 0,
        left: 0,
        x: elementRect.x,
        y: elementRect.y,
        width: elementRect.width,
        height: elementRect.height
      } : null,

    ...elementComputedStyleProperties.reduce(
      (accumulator, currentValue) => ({
        ...accumulator,
        [currentValue]: elementComputedStyle[currentValue]
      }), {}
    ),

    ...Array.from(
      element.childNodes
    ).some(
      ({ nodeType, TEXT_NODE }) =>
        nodeType === TEXT_NODE
    ) ? {
        text: {
          value: element.innerText
        }
      } : null
  }

  return {
    value,
    children: Array.from(element.children)
      .map(child => computeStyle({
        element: child,
        depth: depth + 1
      }))
  }
}

export default computeStyle
